<template>
  <div class="map-overlay top">
    <div class="map-overlay-inner">
      <fieldset>
        <div v-for="item in info.values" :key="item">
          
          <b>{{$t($route.name+'.mapOverlayBox'+item.name)}}:</b>
        
        
          {{item.value}} {{item.unit}}
        
      
      
          <base-progress
          :type="item.progressType"
          class="pt-0"
          :show-percentage="false"
          :value="item.progress"
          />
          
        </div>
        
      </fieldset>
    </div>
  </div>
</template>
<script>

import BaseProgress from "./BaseProgress"

const MAX_TEMPERATURE = 150;
const MAX_REL_HUM     = 100;
const MAX_RAINMETER   = 150;
const MIN_TEMPERATURE = -50;
const MIN_REL_HUM     = 0;
const MIN_RAINMETER   = 0;

const TEMP_INDEX      = 0;
const HR_INDEX        = 1;
const RAIN_INDEX      = 2;

var info = {
  module_name:     "",
  values: [
    {
      name:         "Temperature",
      value:        0,
      progress:     0,
      progressType: 0
    },
    {
      name:         "RelHumidity",
      value:        0,
      progress:     0,
      progressType: 0
    },
    {
      name:         "Rainmeter",
      value:        0,
      progress:     0,
      progressType: 0
    },
  ]
}

export default {
  name: "ModInfoOverlayBox",
  components: {
    BaseProgress,
  },
  props: {
    module_name:  String,
    temperature:  Number,
    rel_humidity: Number,
    rainmeter:    Number
  },
  mounted(){
    this.updateValues();
  },
  watch : {
    'module_name': function(){
      this.updateValues();
    },
  },
  methods: {
    updateValues: function(){
      this.info.module_name = this.module_name;

      /* Temperature */
      this.info.values[TEMP_INDEX].value = this.temperature;
      this.info.values[TEMP_INDEX].unit = "ºC";
      this.info.values[TEMP_INDEX].progress = getProgress(this.temperature, MAX_TEMPERATURE, MIN_TEMPERATURE);
      this.info.values[TEMP_INDEX].progressType = getProgressType(this.temperature, MAX_TEMPERATURE, MIN_TEMPERATURE);

      /* RH */
      this.info.values[HR_INDEX].value = this.rel_humidity;
      this.info.values[HR_INDEX].unit = "%";
      this.info.values[HR_INDEX].progress = getProgress(this.rel_humidity, MAX_REL_HUM, MIN_REL_HUM);
      this.info.values[HR_INDEX].progressType = getProgressType(this.rel_humidity, MAX_REL_HUM, MIN_REL_HUM);

      /* Rainmeter */
      this.info.values[RAIN_INDEX].value = this.rainmeter;
      this.info.values[RAIN_INDEX].unit = "L";
      this.info.values[RAIN_INDEX].progress = getProgress(this.rainmeter, MAX_RAINMETER, MIN_REL_HUM);
      this.info.values[RAIN_INDEX].progressType = getProgressType(this.rainmeter, MAX_RAINMETER, MIN_RAINMETER);
    }
  },
  data() {
    return {
      info
    };
  }  
};

function getProgress(cur, max, min){
  return (cur+abs(min))/(max+abs(min)) *100;
}

function getProgressType(cur, max, min){
  var ret = "gradient-success";
  if((cur+abs(min)) > (max+abs(min))*2/3){
    ret = "gradient-danger";
  } else if((cur+abs(min)) > (max+abs(min))/3){
    ret = "gradient-warning";
  }else{
    ret = "gradient-success";
  }
  return ret;
}

function abs(value){
  var ret = value;
  if(value < 0){
    ret = value * (-1);
  }
  return ret;
}

</script>
<style>
.map-overlay {
font: 12px/20px 'Helvetica Neue', Arial, Helvetica, sans-serif;
position: relative;
width: 100%;
top: 0;
left: 0;
padding: 10px;
z-index: 9
}
 
.map-overlay .map-overlay-inner {
background-color: #fff;
box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
border-radius: 3px;
padding: 10px;
margin-bottom: 10px;
}
 
.map-overlay-inner fieldset {
border: none;
padding: 0;
margin: 0 0 10px;
}
 
.map-overlay-inner fieldset:last-child {
margin: 0;
}
 
.map-overlay-inner select {
width: 100%;
}
 
.map-overlay-inner label {
display: block;
font-weight: bold;
margin: 0 0 5px;
}
 
.map-overlay-inner button {
display: inline-block;
width: 36px;
height: 20px;
border: none;
cursor: pointer;
}
 
.map-overlay-inner button:focus {
outline: none;
}
 
.map-overlay-inner button:hover {
box-shadow: inset 0 0 0 3px rgba(0, 0, 0, 0.1);
}
</style>